// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__ei51b","rootSuccess":"CompleteLink_rootSuccess__wG7Wk","rootFailure":"CompleteLink_rootFailure__3g2ap","isDisabled":"CompleteLink_isDisabled__qHKu-"};